// extracted by mini-css-extract-plugin
export var container = "styles-module--container--a3091";
export var content = "styles-module--content--9d1f7";
export var header = "styles-module--header--dc33d";
export var image = "styles-module--image--c0e15";
export var offWhite = "styles-module--offWhite--c3589";
export var section = "styles-module--section--dc739";
export var tab = "styles-module--tab--806d4";
export var tabButton = "styles-module--tabButton--db213";
export var tabContent = "styles-module--tabContent--0e39e";
export var tabs = "styles-module--tabs--cc608";
export var title = "styles-module--title--71bf1";
export var visible = "styles-module--visible--89716";
export var white = "styles-module--white--39f31";